"use client";
import React from "react";
import HeroSection from "./hero-section/HeroSection";
import DiscoverSection from "./discover-section/DiscoverSection";
import SignatureDishesSection from "./signature-dishes-section/SignatureDishesSection";
import MenuSection from "./menu-section/MenuSection";
import MealSection from "./meal-section/MealSection";
import ReservationForm from "../menu/reservation-form/ReservationForm";
import TestimonialsSection from "./testimonials/Testimonials";

const Home = () => {
  return (
    <>
      <HeroSection />
      <DiscoverSection />
      <SignatureDishesSection />
      <MealSection />
      <MenuSection />
      <TestimonialsSection />
      <ReservationForm />
    </>
  );
};

export default Home;
